import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGetUserDqlQuery } from '../../../../../api/denali'
import SavedQueryProvider, { useSavedQuery } from './SavedQueryProvider'
import QueryEditor from './QueryEditor'

function QueryToolContent () {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const queryId = params.get('queryId')
  const fromAssistant = params.get('fromAssistant')
  const initializedRef = useRef(false)

  const { loadQuery, currentQuery } = useSavedQuery()
  const { data } = useGetUserDqlQuery(queryId ? Number(queryId) : null, {
    enabled: !!queryId
  })

  // Load saved query by ID. Keyed off the fetched query's ID so it also
  // works when navigating from one saved query to another.
  useEffect(() => {
    if (data?.query) {
      if (!currentQuery || currentQuery.userDqlQueryId !== data.query.userDqlQueryId) {
        loadQuery(data.query)
      }
    }
  }, [data, loadQuery, currentQuery])

  // Pick up DQL from assistant via localStorage (cross-tab)
  const assistantDql = (!queryId && fromAssistant && !initializedRef.current)
    ? localStorage.getItem('denaliQueryToolDql')
    : null

  useEffect(() => {
    if (assistantDql && !initializedRef.current) {
      initializedRef.current = true
      localStorage.removeItem('denaliQueryToolDql')
    }
  }, [assistantDql])

  return <QueryEditor initialDql={assistantDql} />
}

function QueryToolHome () {
  return (
    <SavedQueryProvider>
      <QueryToolContent />
    </SavedQueryProvider>
  )
}

export default QueryToolHome
